import { withSvgIcon } from './withSvgIcon';

export const AdvancedApi = withSvgIcon(
  <>
    <path
      d="M8.00039 3.78906L3.93295 5.62042C3.00021 6.04039 2.40039 6.96826 2.40039 7.99119V16.0025C2.40039 17.0254 3.00021 17.9533 3.93295 18.3732L8.00039 20.2046V18.8886L4.42562 17.279C3.92337 17.0529 3.60039 16.5533 3.60039 16.0025V7.99119C3.60039 7.44038 3.92337 6.94076 4.42562 6.71462L8.00039 5.10509V3.78906Z"
      fill="currentColor"
    />
    <path
      d="M15.9996 3.78906L20.067 5.62042C20.9998 6.04039 21.5996 6.96826 21.5996 7.99119V16.0025C21.5996 17.0254 20.9998 17.9533 20.067 18.3732L15.9996 20.2046V18.8886L19.5744 17.279C20.0766 17.0529 20.3996 16.5533 20.3996 16.0025V7.99119C20.3996 7.44038 20.0766 6.94076 19.5744 6.71462L15.9996 5.10509V3.78906Z"
      fill="currentColor"
    />
    <path
      d="M8 13.5448L16 9.71875V11.0489L8 14.875V13.5448Z"
      fill="currentColor"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
